import api from './utils/api';

class AboutsService {
  async listAbouts(body) {
    let url = '/abouts';

    if (body) {
      url = `/abouts?gender=${body}`;
    }

    const result = await api.get(url);
    return result.data;
  }

  async listLanguagesModel(id) {
    const result = await api.get(`/model-languages/${id}`);
    return result.data;
  }

  async upsertModelLanguages(data) {
    const result = await api.put('/model-languages', data);

    return result;
  }

  async getModelAbouts() {
    const result = await api.get('/model-about');

    return result.data;
  }

  async upsertModelAbout(data) {
    const result = await api.put('/model-about', data);

    return result;
  }

  async upsertModelAboutBatch(items) {
    const response = await api.put('/model-about/batch', { items });
    return response.data;
  }

  async deleteModelAbout(aboutId) {
    const response = await api.delete(`/model-about/${aboutId}`);
    return response.data;
  }

  async deleteModelLanguages(id) {
    await api.delete(`/model-languages/${id}`);
  }
}

export default new AboutsService();
